import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import {  getUsagesAllURL } from '../utils/api';

const useGetUsagesAll = ({ 
        page = 1,
        limit = 3000,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingUsages, setGettingUsages ] = useState(false);
    const [ usages, setUsages ] = useState([]);
    const [ totalUsages, setTotalUsages ] = useState(0);
    const [ gettingUsagesReqSuccess, setGettingUsagesReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingUsages) {
            axios.get(getUsagesAllURL,
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
            }).then(result => {
                setGettingUsages(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    // console.log(data);
                    if (result.data.total) {
                        setTotalUsages(result.data.total);
                    }
                    setGettingUsagesReqSuccess(true);
                    setUsages(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingUsagesReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingUsagesReqSuccess(false);
                setGettingUsages(false);
            });
        }
    }, [gettingUsages]);

    return { usages, totalUsages, gettingUsages, setGettingUsages, gettingUsagesReqSuccess };
}

export default useGetUsagesAll;